// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".store-item[data-v-5f06ef60]{height:50px!important}.store-img[data-v-5f06ef60]{width:40px;height:40px;margin-right:5px}.v-list[data-v-5f06ef60] .v-list-item{max-height:50px!important}.label-switch[data-v-5f06ef60]{font-weight:600}", ""]);
// Exports
module.exports = exports;
